import React from 'react';
import ScenarioGenerator from './components/ScenarioGenerator';
import './App.css';

function App() {
  return (
    <div className="App">
      <ScenarioGenerator />
    </div>
  );
}

export default App;
